// Swiper 6.0+
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

export class Swp {
  constructor() {
    this.swiperCover = {};
    this.swipersLocation = [];
  }

  init() {
    //this.body = document.getElementsByTagName('body')[0];
    //this.html = document.getElementsByTagName('html')[0];

    // index > location
    // ------------
    if (document.querySelectorAll(".index-location__swiper")[0]) {
      // Swiper slider + thumbnails
      this.targetElems = document.querySelectorAll(".index-location__swiper");
      //console.log(this.targetElems);
      for (let i = 0; i < this.targetElems.length; i++) {
        console.log("location-slider");
        this.swipersLocation[i] = new Swiper(this.targetElems[i], {
          modules: [Navigation, Pagination, Autoplay],
          effect: "slide",
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          speed: 6000,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          initialSlide: 0,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            700: {
              autoplay: {
                delay: 0,
                disableOnInteraction: false,
              },
              speed: 8000,
              slidesPerView: 2,
              initialSlide: 0,
            },
            1000: {
              autoplay: {
                delay: 0,
                disableOnInteraction: false,
              },
              speed: 8000,
              slidesPerView: 3,
              // spaceBetween: 0,
              //centeredSlides: true,
              initialSlide: 0,
            },
          },
          on: {
            beforeInit: () => {},
            init: function () {
              //   let windowWidth =
              //     window.innerWidth || document.documentElement.clientWidth || 0;
              //   if (windowWidth >= 1000) {
              //     this.slideNext(); //centeredSlidesだと最初のスライドが中央にならないので、スライドを一つ進める
              //   }
              //console.log(this.params);
              this.el.classList.add("is-show");
              //this.params.autoplay.delay = 1200;
              //this.params.autoplay.disableOnInteraction = true;
              //this.autoplay.start();
            },
          },
        });
      }
    }

    // index > cover
    // ------------
    if (document.querySelectorAll(".swiper--index-cover")[0]) {
      // Swiper slider + thumbnails

      this.targetElem = document.querySelector(".swiper--index-cover");
      this.swiperCover = new Swiper(this.targetElem, {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        effect: "fade",
        autoplay: false,
        speed: 1200,
        slidesPerView: 1,
        //lazy: true,
        loop: true,
        initialSlide: 0,
        allowTouchMove: false,
        on: {
          beforeInit: () => {},
          init: function () {
            //console.log(this, "init");
            //   let windowWidth =
            //     window.innerWidth || document.documentElement.clientWidth || 0;
            //   if (windowWidth >= 760) {
            //     this.slideNext(); //centeredSlidesだと最初のスライドが中央にならないので、スライドを一つ進める
            //   }
            //console.log(this.params);
            //this.el.classList.add("is-show");
            this.params.autoplay.delay = 3000;
            this.params.autoplay.disableOnInteraction = true;
            this.autoplay.start();
          },
        },
      });
    }

    //
  }
}
